// ----------------------
// <auto-generated>
// Generated using the script apiGenerator.js
// </auto-generated>
// -----------------------
import { configuration } from 'config/constants';
import {
    CategoriesClient,
    SearchsClient,
} from './SgmSearchApiClient';
import { http } from 'services/ApiService/Http';

const { baseApiUrls: { sgmSearch: baseApiUrl } } = configuration;

export const CategoriesApi = new CategoriesClient(baseApiUrl, http);
export const SearchsApi = new SearchsClient(baseApiUrl, http);
